import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import * as E from '../homeElements'
import { ISettlementStageProps } from './interfaces/ISettlementStageProps'
import BannerBrandImageSection from 'components/bannerBrandImageSection'
import BannerMainImageSection from 'components/bannerMainImageSection'

const SettlementStage = (props: ISettlementStageProps) => {
  const { firstName, vehicleDescription, proposalLink, settlementLink } = props

  return (
    <>
      <BannerMainImageSection>
        <E.WhiteHeading>Oly novated LEASE</E.WhiteHeading>
        <h1 style={{color:'#fff'}}>The wheels are in motion!</h1>
      </BannerMainImageSection>

      <BannerBrandImageSection id="maincontent">
        <E.ContainerBlock>
          <E.BannerButtonLinkParent>
            <Col sm={7}>
              <E.BannerButtonTitleRow>
                It's time for the final step {firstName}!
              </E.BannerButtonTitleRow>
              <Row>
                Your final step to get behind the wheel of your new{' '}
                {vehicleDescription} is to sign your lease documents. Please
                click 'Sign my documents' to go to the paperwork page to be
                directed to Adobe Sign, where you can easily sign
                electronically.
                <br />
                Once you're done, Oly will organise for your employer to sign
                the documents and have everything ready to finalise your lease.
                <br />
                <strong>
                  If you have organised your own comprehensive insurance, please send our team a copy of your Certificate of
                  Insurance if you haven’t already.
                </strong>
              </Row>
            </Col>
            <E.BannerButtonLinkChild>
              <Link to={settlementLink} tabIndex={-1}>
                <E.BannerPrimaryButton>Sign my documents</E.BannerPrimaryButton>
              </Link>
              <br />
              <Link to={proposalLink} tabIndex={-1}>
                <E.BannerPrimaryInverted invertColor brand={'oly'}>
                  View my proposal again
                </E.BannerPrimaryInverted>
              </Link>
            </E.BannerButtonLinkChild>
          </E.BannerButtonLinkParent>
        </E.ContainerBlock>
      </BannerBrandImageSection>
    </>
  )
}

export default SettlementStage
